import { Injectable } from '@angular/core';

@Injectable()
export class VideoUputstvaService {
  constructor() {}

  getSettings() {
    return {
      additable: false,
      allFields: [this.getNameFieldSettings()],
      completerMainAndSecond: true,
      completerMainField: '',
      completerSecondField: '',
      deletable: false,
      details: [],
      documentType: 'Sifarnik',
      editable: false,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: ['111-111-111'],
        lookupTable: [],
      },
      fromCode: '',
      group: 'VideoUputstva',
      idProperty: 'id',
      inlineAdding: false,
      inlineEditing: false,
      lazyListSource: 'mainAndSecond',
      name: 'VideoUputstva',
      relations: [],
      title: 'Video uputstva',
      type: 'videouputstva',
      path: '',
      _id: '51073157',
    };
  }

  getNameFieldSettings() {
    return {
      additable: false,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Naziv',
      entityType: 'Naziv',
      id: '111-111-111',
      label: 'Naziv',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Naziv',
      path: null,
      type: 'input',
      width: 10,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/video-uputstva.service.ts